import store from "../../store/index"
import {getTimesheets} from "../../api/timesheet.api";

import {
  approvedTimesheetsStatuses,
  awaitingApprovalTimesheetsStatuses,
  awaitingSubmissionTimesheetStatuses,
  submittedTimesheetsStatuses
} from "../constants/timesheets";

const getManagedAbsences = function (timesheet) {
  let absenceTypeOptions = [];
  const absences = timesheet.Days.Absences[0];
  if (absences.Managed === "Yes") {
    absences.AbsencesList.forEach(element => {
      absenceTypeOptions.push(element);
    });
    return absenceTypeOptions;
  }
  return [];
}

const checkIfAttachmentRequired = function(timesheet) {
  const allAbsences = getManagedAbsences(timesheet);
  const absencesWihRequiredAttachment = allAbsences.filter(absence => absence.Attachment.toLowerCase() === "yes");
  let isRequired = false;

  if (absencesWihRequiredAttachment.length < 1) {
    return isRequired;
  }
  for (let day of timesheet.Days.Days) {
    if (day.absence === "1" && absencesWihRequiredAttachment.find(absence => absence.code === day.absenceCode)) {
      isRequired = true;
      break;
    }
  }

  return isRequired;
}

const checkIfRequiredAttachmentMissing = function (timesheet) {
  if (!checkIfAttachmentRequired(timesheet)) {
    return false;
  }

  return !timesheet.Attachments.length;
}

const checkIfOvertimeCommentMissing = function (timesheet) {
  let isRequired = false;
  for (let day of timesheet.Days.Days) {
    if (
      (parseFloat(day.ot1) > 0 || parseFloat(day.ot2) > 0 || parseFloat(day.ot3) > 0) &&
      (typeof day.Remarks !== "string" || (typeof day.Remarks === "string" && day.Remarks.length < 1))
    ) {
      isRequired = true;
      break;
    }
  }

  return isRequired;
}

const checkIfOvertimeCommentTooLong = function (timesheet) {
  const maxLength = 100;
  let invalid = false;
  for (let day of timesheet.Days.Days) {
    if (day.Remarks && day.Remarks.length > 100) {
      invalid = true;
      break;
    }
  }

  return invalid;
}

const setTimesheetsInStore = async function (user, timesheets = null) {
  if (!timesheets) {
    let timesheetsArray = [];
    await getTimesheets(JSON.parse(sessionStorage.getItem("loggedAs"))).then(
      (response) => {
        response.data.TimesheetsSummaries.forEach(contract => {
          contract.Timesheets.forEach(timesheet => {
            timesheetsArray.push(timesheet);
          })
        })
      timesheets = timesheetsArray;
    }, (error) => {
      this.handleApiError(error);
    });
  }


  orderTimesheetsByDate(timesheets);

  if (store.getters["auth/role"] === 'Worker' || store.getters["auth/role"] === 'Freelancer') {
    let awaitingSubmissionTimesheet = timesheets.filter(t => awaitingSubmissionTimesheetStatuses.includes(t.status))
    let submittedTimesheets = timesheets.filter(t => submittedTimesheetsStatuses.includes(t.status))
    store.dispatch("timesheets/changeAwaitingSubmissionTimesheet", awaitingSubmissionTimesheet.map(t => t.id));
    store.dispatch("timesheets/changeSubmittedTimesheets", submittedTimesheets.map(t => t.id));
  }

  if (store.getters["auth/role"] === 'Approver') {
    let awaitingApprovalTimesheets = timesheets.filter(t => awaitingApprovalTimesheetsStatuses.includes(t.status))
    let approvedTimesheets = timesheets.filter(t => approvedTimesheetsStatuses.includes(t.status))
    store.dispatch("timesheets/changeAwaitingApprovalTimesheets", awaitingApprovalTimesheets.map(t => t.id));
    store.dispatch("timesheets/changeApprovedTimesheets", approvedTimesheets.map(t => t.id));
  }

  store.dispatch("timesheets/changeTimesheetIdsAreLoaded", true);
}

const orderTimesheetsByDate = function (timesheets) {
  timesheets.sort(function (a, b) {
    let dateParts = a.StartDate.split("/");
    const d1 = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
    dateParts = b.StartDate.split("/");
    const d2 = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
    return d2.getTime() - d1.getTime();
  })
}

export {
  getManagedAbsences,
  checkIfAttachmentRequired,
  checkIfOvertimeCommentMissing,
  checkIfRequiredAttachmentMissing,
  checkIfOvertimeCommentTooLong,
  setTimesheetsInStore,
  orderTimesheetsByDate
}
